import React from 'react'
import './Intro.css'
import FloatingDiv from "../FloatingDiv/FloatingDiv";

import Github from '../../img/github.png';
import LinkedIn from '../../img/linkedin.png';
import Instagram from '../../img/instagram.png';
import Vector1 from '../../img/Vector1.png';
import Vector2 from '../../img/Vector2.png';
import boy from '../../img/divakar.png';
import thumbup from '../../img/thumbup.png';
import Crown from '../../img/crown.png';
import glassesimoji from '../../img/glassesimoji.png';
import { themeContext } from '../../Context'
import { useContext } from 'react'
import {motion} from 'framer-motion'


const Intro = () => {

    const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode
    const transition = {duration : 2, type : 'spring'}

    return (
        <div className="intro">
            <div className="i-left">
                <div className="i-name">
                    <span style={{color: darkMode? 'white': ''}}>Hey! I Am</span>
                    <span>Divakar Choudhary</span>
                    <span style={{color: darkMode? 'white': ''}}>Web Developer with good level of experience in web designing and development, producing the Quality work</span>
                </div>
                <a href="mailto:divakarkumarchy2001@gmail.com" >
                    <button className="button i-button">Hire me</button>
                </a>
                <div className="i-icons">
                    <a href="https://github.com/choudhary2001/"> <img src={Github} alt="" /></a>
                    <a href="https://linkdin.com/divakar-kumar-choudhary"><img src={LinkedIn} alt="" /></a>
                    <a href="https://instagram.com/divakarkumar.choudhary"> <img src={Instagram} alt="" /> </a>

                </div>
            </div>
            <div className="i-right">
                <img src={Vector1} alt="" />
                <img src={Vector2} alt="" />
                <img src={boy} alt="" />
                <motion.img
                initial ={{left: '-36%'}}
                whileInView = {{left: '-24%'}}
                transition = {transition}


                src={glassesimoji} alt="" />
                <motion.div
                initial ={{top : '-4%', left: '74%'}}
                whileInView ={{left: '68%'}}
                transition = {transition}
                className="floating-div"
                style={{ top: '-4%', left: '68%', color: darkMode? 'black': '' }}>
                    <FloatingDiv image={Crown} text1='Web' text2='Developer'></FloatingDiv>
                </motion.div>
                <motion.div
                initial ={{top : '18rem', left: '9rem'}}
                whileInView ={{left: '0rem'}}
                transition = {transition}
                className="floating-div"
                 style={{ top: '18.2rem', left: '2rem', color: darkMode? 'black': '' }}>
                    <FloatingDiv image={thumbup} text1='Problem' text2='Solver' />
                </motion.div>
                {/* Blur div */}
                <div className="blur right-blur"></div>
                <div className="blur left-blur"></div>
            </div>
        </div>
    )
}

export default Intro